/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Study_Theatre_Film_Media21Inputs */

const en__field_enum_study_theatre_film_media21 = /** @type {(inputs: _Field_Enum_Study_Theatre_Film_Media21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Theatre, Film and Media Studies`)
};

const de__field_enum_study_theatre_film_media21 = /** @type {(inputs: _Field_Enum_Study_Theatre_Film_Media21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Theater-, Film- u. Medienwissenschaft`)
};

/**
* | output |
* | --- |
* | "Theatre, Film and Media Studies" |
*
* @param {_Field_Enum_Study_Theatre_Film_Media21Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_study_theatre_film_media21 = /** @type {((inputs?: _Field_Enum_Study_Theatre_Film_Media21Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Study_Theatre_Film_Media21Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_study_theatre_film_media21(inputs)
	return de__field_enum_study_theatre_film_media21(inputs)
});
export { _field_enum_study_theatre_film_media21 as "_field_enum_STUDY_THEATRE_FILM_MEDIA" }